var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-around h-100"},[(_vm.$route.name ==='orders' ||
          _vm.$route.name ==='ordersControl' ||
          _vm.$route.name ==='ordersProtect' ||
          _vm.$route.name ==='ordersCancellations' ||
          _vm.$route.name ==='ordersCollection' ||
          _vm.$route.name ==='ordersTasks' ||
          _vm.$route.name ==='ordersClaims' ||
          _vm.$route.name ==='renewals' ||
          _vm.$route.name ==='leads')?_c('input',{staticClass:"align-self-center",attrs:{"type":"checkbox","name":"preview-order-list","id":_vm.id},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('catchPreviewList', _vm.phoneNumber, _vm.productSelectedRow)}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }